import {
  Box,
  Flex,
  Heading,
  Tag,
  Text,
  useTheme,
} from "@chakra-ui/react";
import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import BackButton from "../../components/BackButton";
import DirectionsButton from "../../components/search/DirectionsButton";
import FavouriteButton from "../../components/FavouriteButton";
import HybridBottomSheetDrawer from "../../components/HybridBottomSheetDrawer";
import QueryStateWrapper from "../../components/QueryStateWrapper";
import { useHiddenGemsLocations } from "../../data/hiddenGems.api";
import { useFocusOnLngLat } from "../../hooks/useFocusOnLngLat";

const ViewHiddenGem = () => {
  const { id } = useParams<{ id: string }>();
  const { data: locations, isLoading, error } = useHiddenGemsLocations();
  const theme = useTheme();

  const location = useMemo(() => {
    return locations?.find((loc) => loc.key === id);
  }, [locations, id]);

  useFocusOnLngLat(
    location?.longitude ?? undefined,
    location?.latitude ?? undefined,
    useMemo(
      () => ({
        color: theme?.colors?.["lancsRed"]?.["300"],
      }),
      [theme]
    )
  );

  return (
    <HybridBottomSheetDrawer>
      <Box p={8}>
        <BackButton />
        <QueryStateWrapper isLoading={isLoading} error={error} data={location}>
          <Flex justify="space-between" mb={3}>
            <Heading size="md">{location?.name}</Heading>
            <FavouriteButton name={location?.name ?? ""} />
          </Flex>

          {location?.tags && location.tags.length > 0 && (
            <Flex flexWrap="wrap" gap={1} mb={4}>
              {location.tags.map((tag) => (
                <Tag key={tag} size="sm">
                  {tag}
                </Tag>
              ))}
            </Flex>
          )}

          {location?.buildingName && (
            <Text fontSize="sm" color="gray.500" mb={2}>
              {location.buildingName}
            </Text>
          )}

          {(location?.capacity ?? 0) > 0 && (
            <Text fontSize="sm" color="gray.500" mb={4}>
              Capacity: {location?.capacity}
            </Text>
          )}

          <Flex flexWrap="wrap" gap={2} mt={4}>
            {location?.longitude && location?.latitude && (
              <DirectionsButton
                lng={location.longitude}
                lat={location.latitude}
              />
            )}
          </Flex>
        </QueryStateWrapper>
      </Box>
    </HybridBottomSheetDrawer>
  );
};

export default ViewHiddenGem;
